var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import Api from '../model/api';
import SessionView from '../module/session-view';
import UserModule from '../module/user';
import SessionDbModule from '../module/session-db';
import I18n, * as i18nKey from '../module/i18n';
import { decorator } from '../utils/instance';
import Emitter from '../utils/emitter';
import { toBool } from '../utils/boolean';
var START_FETCH_COUNT = 20;
var MAX_FETCH_COUNT = 100;
var SessionList = (function (_super) {
    __extends(SessionList, _super);
    function SessionList(config) {
        var _this = _super.call(this) || this;
        _this._count = 1;
        _this._sessMap = {};
        _this.updateSessionByData = function (sessionData, type) {
            var _sessDb = _this._sessDb;
            var localSession = _sessDb.get(sessionData.sessionId);
            var sessionView = _this.getSessionView(sessionData.sessionId);
            if (sessionView) {
                if (sessionView.toPosition < sessionData.toPosition) {
                    sessionView.updateToReadStatus(sessionData.toPosition);
                }
                Object.assign(sessionView, sessionData);
            }
            _sessDb.set(Object.assign({}, localSession, sessionData), type);
        };
        _this.config = config;
        _this._api = Api.getInstance(config);
        _this._user = UserModule.getInstance(config);
        _this._sessDb = SessionDbModule.getInstance(config);
        _this._i18n = I18n.getInstance(config);
        return _this;
    }
    SessionList.prototype.init = function () {
        var _sessDb = this._sessDb;
        if (_sessDb.syncId > 0) {
            return Promise.resolve();
        }
        else {
            this._count = 1;
            return this._fetchSessionList(START_FETCH_COUNT);
        }
    };
    SessionList.prototype.setConversationSession = function (sessionId, nonReadNumber, startTime, clearCache) {
        return __awaiter(this, void 0, void 0, function () {
            var _sessDb, sessionData, sessionView;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (sessionId === -1 && this.conversationSession) {
                            this.conversationSession.isConversation = false;
                            this.conversationSession = null;
                            return [2, Promise.resolve(this.conversationSession)];
                        }
                        _sessDb = this._sessDb;
                        sessionData = _sessDb.get(sessionId);
                        if (!sessionId || !sessionData) {
                            return [2, Promise.reject({ type: 'NOT_FIND_SESSION', message: this._i18n.getTxt(i18nKey.NOT_FIND_SESSION) })];
                        }
                        sessionView = this.getSessionView(sessionId);
                        if (clearCache && this._sessMap) {
                            this._sessMap = {};
                        }
                        if (!sessionView) {
                            sessionView = new SessionView(this.config, sessionData, { fromCode: this.config.fromCode });
                            this._sessMap[sessionData.sessionId] = sessionView;
                        }
                        if (this.conversationSession) {
                            this.conversationSession.isConversation = false;
                        }
                        sessionView.isConversation = true;
                        this.conversationSession = sessionView;
                        return [4, sessionView.init(startTime || -1)];
                    case 1:
                        _a.sent();
                        sessionView.checkAndEmitNewMessage();
                        sessionView.setAllRead(nonReadNumber, true);
                        return [2, Promise.resolve(sessionView)];
                }
            });
        });
    };
    SessionList.prototype.getSessionList = function () {
        return this._sessDb.getAll();
    };
    SessionList.prototype.getSessionView = function (sessionId) {
        return this._sessMap[sessionId];
    };
    SessionList.prototype.createSessionView = function (sessionData, fromCode) {
        if (!sessionData || !sessionData.sessionId) {
            return {};
        }
        var config = this.config;
        fromCode = fromCode || this.config.fromCode;
        var sessionView = this.getSessionView(sessionData.sessionId);
        if (!sessionView) {
            sessionView = new SessionView(config, sessionData, { fromCode: fromCode });
            this._sessMap[sessionData.sessionId] = sessionView;
        }
        else {
            sessionView.fromCode = fromCode;
            this._sessMap[sessionData.sessionId] = sessionView;
        }
        return sessionView;
    };
    SessionList.prototype.deleteSession = function (sessionId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, config, _sessDb, param, conversationSession;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this, config = _a.config, _sessDb = _a._sessDb;
                        param = {
                            accessKey: config.accessKey,
                            accessToken: config.accessToken,
                            sessionId: sessionId,
                        };
                        return [4, this._api.request(config._url.deleteSession, param).catch(function (err) {
                                return {};
                            })];
                    case 1:
                        _b.sent();
                        conversationSession = this.conversationSession;
                        if (conversationSession && conversationSession.sessionId === sessionId) {
                            this.conversationSession = null;
                        }
                        if (this._sessMap[sessionId]) {
                            delete this._sessMap[sessionId];
                        }
                        if (_sessDb.get(sessionId)) {
                            _sessDb.delete(sessionId);
                        }
                        return [2];
                }
            });
        });
    };
    SessionList.prototype.openSession = function (accountId, accountType, fromCode, extra) {
        var _a, _b;
        if (accountType === void 0) { accountType = 2; }
        if (extra === void 0) { extra = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var config, sessionType, param, data, newSessionData, sessionData, sessionView;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        config = this.config;
                        sessionType = 103;
                        param = __assign({ accessKey: config.accessKey, accessToken: config.accessToken, toAccountId: accountId, toAccountType: accountType, sessionType: sessionType }, extra);
                        return [4, this._api.request(config._url.openSession, param).catch(function (err) {
                                return {};
                            })];
                    case 1:
                        data = _c.sent();
                        newSessionData = (_b = (_a = data === null || data === void 0 ? void 0 : data.session) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.typeData;
                        sessionData = this.getParseSessionData(newSessionData);
                        sessionView = this.createSessionView(sessionData, fromCode);
                        this._sessDb.set(sessionData);
                        return [2, sessionView];
                }
            });
        });
    };
    SessionList.prototype.getParseSessionData = function (sessionPacket) {
        var config = this.config;
        var sessionData = sessionPacket.sessionData, sessionId = sessionPacket.sessionId, status = sessionPacket.status, target = sessionPacket.target, type = sessionPacket.type;
        var sessionData2 = __assign(__assign({}, sessionData), { sessionId: sessionId, title: sessionData.title || '', headUrl: sessionData.headUrl || config.userDefaultHeadMap[target.userAccountType] || '', status: parseInt((status || 0)), nonReadNumber: parseInt((sessionData.nonReadNumber || 0)), viewModifyTime: parseInt((sessionData.viewModifyTime || 0)), lastMessageTime: parseInt((sessionData.lastMessageTime || 0)), selfPosition: parseInt((sessionData.selfPosition || 0)), toPosition: parseInt((sessionData.toPosition || 0)), content: sessionData.content || '', type: parseInt(type), toUser: {
                headUrl: sessionData.headUrl || config.userDefaultHeadMap[target.userAccountType] || '',
                nickName: sessionData.title || '',
                userId: target.targetId,
                userType: target.userAccountType,
            }, senderAccountType: parseInt((sessionData.senderAccountType || 0)) });
        if (!sessionData2.title) {
            var toUser = this._user.getUserData(target.userAccountType, target.targetId);
            if (toUser) {
                sessionData2.headUrl = toUser.headUrl;
                sessionData2.title = toUser.nickName;
                sessionData2.toUser = toUser;
            }
        }
        return sessionData2;
    };
    SessionList.prototype.hasMoreSession = function (resp) {
        return toBool(resp.hasMore);
    };
    SessionList.prototype._fetch = function (fetchCount) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, config, _sessDb, param, data, _b, syncId, syncNamespace;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this, config = _a.config, _sessDb = _a._sessDb;
                        param = {
                            accessKey: config.accessKey,
                            accessToken: config.accessToken,
                            accountType: config.accountType,
                            nodeId: _sessDb.nodeId,
                            startTime: _sessDb.startTime,
                            fetchCount: fetchCount,
                            pageNum: this._count
                        };
                        return [4, this._api.request(config._url.initNode, param).catch(function (err) {
                                return {};
                            })];
                    case 1:
                        data = _c.sent();
                        this._count += 1;
                        if (data.syncData) {
                            _b = data.syncData, syncId = _b.syncId, syncNamespace = _b.syncNamespace;
                            _sessDb.setAttr({ syncId: syncId, syncNamespace: syncNamespace });
                        }
                        return [2, Promise.resolve(data)];
                }
            });
        });
    };
    SessionList.prototype._fetchSessionList = function (fetchCount) {
        if (fetchCount === void 0) { fetchCount = START_FETCH_COUNT; }
        return __awaiter(this, void 0, void 0, function () {
            var resp, rawSessionData, sessionData, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, this._fetch(fetchCount)];
                    case 1:
                        resp = _a.sent();
                        rawSessionData = resp.sessionViewDTOList || [];
                        return [4, this.suppleUserData(rawSessionData, 'fetch')];
                    case 2:
                        sessionData = _a.sent();
                        if (this.hasMoreSession(resp)) {
                            this._fetchSessionList(MAX_FETCH_COUNT);
                        }
                        this.updateSessionBatch(sessionData);
                        return [2, resp];
                    case 3:
                        err_1 = _a.sent();
                        this._sessDb.markExpired();
                        console.error(err_1);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    SessionList.prototype.fetchMoreSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resp, rawSessionData, sessionData, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, this._fetch(MAX_FETCH_COUNT)];
                    case 1:
                        resp = _a.sent();
                        rawSessionData = resp.sessionViewDTOList || [];
                        return [4, this.suppleUserData(rawSessionData, 'fetch')];
                    case 2:
                        sessionData = _a.sent();
                        this.updateSessionBatch(sessionData);
                        return [2, this._sessDb.getAll()];
                    case 3:
                        err_2 = _a.sent();
                        this._sessDb.markExpired();
                        console.error('fetchMoreSession', err_2);
                        throw err_2;
                    case 4: return [2];
                }
            });
        });
    };
    SessionList.prototype.updateSessionBatch = function (sessionArr) {
        var _this = this;
        sessionArr.forEach(function (sessionData) {
            _this.updateSessionByData(sessionData, "back");
        });
    };
    SessionList.prototype.filterSessionData = function (sessionPacket) {
        if (!this.config.onlySupportB2C) {
            return true;
        }
        return parseInt(sessionPacket.type) === 103;
    };
    SessionList.prototype.suppleUserData = function (sessionPackets, ctxType) {
        return __awaiter(this, void 0, void 0, function () {
            var _user, _sessDb, userReq, userDataList, sessionDataList, sessionDataList_1, sessionDataList_1_1, sessionData, user, userInfo, error_1;
            var e_1, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _user = this._user;
                        _sessDb = this._sessDb;
                        userReq = [];
                        userDataList = [];
                        sessionDataList = sessionPackets.filter(function (packet) {
                            return _this.filterSessionData(packet);
                        }).map(function (packet) {
                            var sessionData = _this.getParseSessionData(packet);
                            if (ctxType === 'fetch' &&
                                (_sessDb.startTime < 0 || sessionData.viewModifyTime < _sessDb.startTime)) {
                                _sessDb.setAttr('startTime', sessionData.viewModifyTime);
                            }
                            if (sessionData.title && sessionData.toUser && sessionData.toUser.headUrl) {
                                userDataList.push(sessionData.toUser);
                            }
                            else {
                                userReq.push({
                                    userId: sessionData.toUser.userId,
                                    userType: sessionData.toUser.userType,
                                });
                            }
                            return sessionData;
                        });
                        _user._saveData(userDataList);
                        if (!(userReq.length === 0)) return [3, 1];
                        return [2, Promise.resolve(sessionDataList)];
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4, _user.getUsers(userReq)];
                    case 2:
                        _b.sent();
                        try {
                            for (sessionDataList_1 = __values(sessionDataList), sessionDataList_1_1 = sessionDataList_1.next(); !sessionDataList_1_1.done; sessionDataList_1_1 = sessionDataList_1.next()) {
                                sessionData = sessionDataList_1_1.value;
                                user = sessionData.toUser;
                                userInfo = _user.getUserData(user.userType, user.userId);
                                if (sessionData.type === 103) {
                                    sessionData.toUser = userInfo;
                                    if (userInfo.nickName) {
                                        sessionData.title = userInfo.nickName;
                                        sessionData.headUrl = userInfo.headUrl;
                                    }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (sessionDataList_1_1 && !sessionDataList_1_1.done && (_a = sessionDataList_1.return)) _a.call(sessionDataList_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2, sessionDataList];
                    case 3:
                        error_1 = _b.sent();
                        return [2, Promise.resolve(sessionDataList)];
                    case 4: return [2];
                }
            });
        });
    };
    SessionList = __decorate([
        decorator
    ], SessionList);
    return SessionList;
}(Emitter));
export default SessionList;
